import {
  FormControl,
  FormLabel,
  StandardTextFieldProps,
  styled,
  TextField,
} from "@mui/material";

interface Props extends StandardTextFieldProps {}

export function FilterSectionTextField(props: Props) {
  const { label, fullWidth, className, ...textfieldProps } = props;

  return (
    <StyledFormControl fullWidth={fullWidth} className={className}>
      <FormLabel>{label}</FormLabel>
      <TextField fullWidth={fullWidth} {...textfieldProps} />
    </StyledFormControl>
  );
}

const StyledFormControl = styled(FormControl)`
  .MuiFormLabel-root {
    text-transform: uppercase;
    margin-bottom: ${({ theme }) => theme.spacing(0.5)};
  }
`;
